export default __webpack_public_path__ + "static/underline-after-1ac13720b8b226e0e06e65435907d83b.png";